import React from "react";

export const projectTableHeaderDefination = (data) => {
  if (data.length !== 0) {
    let projects = [];
    projects = projects.concat([data.assets, ...data.contracts, data.epc]);
    projects = projects.map((project, i) => {
      const result = {
        headerName: project.name,
        children: (i === 0 && [{
          headerName: 'name',
          field: 'pname',
          cellRenderer: "agGroupCellRenderer",
          editable: false,
          width: 250,
          textAlign: 'left'
        }]) || [],
      };
      const keys = Object.keys(project.data);
      const values = Object.values(project.data);
      keys.map((key, ind) => {
        if (values[ind].type === 'object') {
          const choices = values[ind].choices.map((choice) => {
            return {name:choice.name,key:choice.key}
          });
          result.children.push({
            headerName: key,
            field: key + i,
            width: 150,
            cellEditorSelector: (params) => {
              if (params.data.pname === "Tied Document?") {
                return {component: 'checkboxAgGridEditor'};
              }else if(params.data.inputType){
                return{component: 'selectAgGridEditor', params: {values: choices}}
              }
              return null
            },
            cellRendererSelector: (params) => {
               if(params.data.inputType){
                return{component: 'selectAgGridRenderer',params: {values: choices}}
              }
              return null
            },
          })
        } else if(values[ind].type === 'boolean'){
          result.children.push({
            headerName: key,
            field: key + i,
            width: 150,
            cellEditorSelector: (params) => {
              if(params.data.inputType || params.data.pname === "Tied Document?"){
                return{component: 'checkboxAgGridEditor'}
              }
              return null
            },
          })
        } else {
          result.children.push({
            headerName: key,
            field: key + i,
            width: 150,
            cellEditorSelector: (params) => {
              if (params.data.pname === "Tied Document?") {
                return {component: 'checkboxAgGridEditor'};
              } else if(params.data.inputType){
                return {component: 'simpleInputAgGridEditor',params:{type:values[ind].type,required:project.required.includes(key) ? key : ''}};
              }
              return null;
            },
            cellRendererSelector: (params) => {
              if(params.data.inputType) {
                return {component: 'simpleInputAgGridRenderer'};
              }
            }
          })
        }

      });
      return result;
    });
    projects.unshift({
      headerName: 'Schema Object',
      children: [{
        headerName: 'Parameter/Input Type',
        field: 'inputType',
        width: 150,
        editable: false,
        cellRendererSelector: (params) => {
          if (params.value) {
            return {component: 'customIcons',params:{id:params.data.projectId,assetSchemaId:params.data.assetSchemaId}};
          }
          return null
        },
      }]
    });
    return projects;
  }
  return [];
};

export const projectRowDefination = (data,assetSchemaId) => {

  return data.map((d,i) => {
    const arrayOfObj = [d.user_project_asset, ...d.user_project_contracts, d.user_project_epc];
    let objectOfResult = {
      projectId: d.id,
      projectIndex: i,
      assetSchemaId,
      inputType: 'Project ' + d.name + ' data',
      pname: 'Project ' + d.name,
      participants: [
        {inputType: '', pname: 'Source'},
        {inputType: '', pname: 'Tied Document?'},
        {inputType: '', pname: 'Verifier'}
      ]
    };
    arrayOfObj.map((obj, i) => {
      const keys = Object.keys(obj.data);
      const addFieldKeys = Object.keys(obj.additional_fields);
      const values = Object.values(obj.data);
      const addFieldsValues = Object.values(obj.additional_fields);

      keys.map((key, ind) => {
        objectOfResult[key + i] =  values[ind].value;
          objectOfResult.participants[0][addFieldKeys[ind] + i] = addFieldsValues[ind].source.value;
          objectOfResult.participants[1][addFieldKeys[ind] + i] = addFieldsValues[ind].tied_document.value;
          objectOfResult.participants[2][addFieldKeys[ind] + i] = addFieldsValues[ind].verifier.value;

      })
    });
    return objectOfResult;
  });
};

export const projectPreEditingFiltering = (data,schema) => {
  const projectValues = Object.values(data);
  let count = 6;

  const result = {
    name: data.pname.slice(8, data.pname.length),
    user_schema: schema.user_schema.id,
    asset: {
      data: {},
      additional_fields: {},
      asset_schema_id: schema.assets.asset_schema_id,
    },
    contracts: [],
    epc: {
      data: {},
      additional_fields: {},
      epc_schema_id: schema.epc.epc_schema_id,
    }
  };

  // assets data set start
  Object.keys(schema.assets.data).map((key, i) => {
    if (schema.assets.data[key].type === 'integer' || schema.assets.data[key].type === 'number') {
      result.asset.data[key] = +projectValues[i + count];
    } else if( schema.assets.data[key].type === 'string'){
      result.asset.data[key] = projectValues[i + count] + '';
    } else if( schema.assets.data[key].type === 'object'){
      result.asset.data[key] = projectValues[i + count];

    }
    result.asset.additional_fields[key] = {
      source: projectValues[5][0] && key !== 'pname' && projectValues[5][0][key + 0] || '',
      verifier: projectValues[5][2] && key !== 'pname' && projectValues[5][2][key + 0]|| '',
      tied_document: Boolean(projectValues[5][1] && key !== 'pname'&& projectValues[5][1][key + 0])
    }
  });
  // assets data set end

  count += Object.keys(schema.assets.data).length;

  // contracts data set start
  result.contracts = schema.contracts.length > 0
    && schema.contracts.map((contract,i) => {
      const contractObj = {
        data: {},
        additional_fields: {},
        contract_schema_id: contract.contract_schema_id,
      };
      Object.keys(contract.data).map((key) => {
        if (contract.data[key].type === 'integer' || contract.data[key].type === 'number') {
          contractObj.data[key] = +projectValues[count];
        } else if(contract.data[key].type === 'boolean'){
          contractObj.data[key] = Boolean(projectValues[count]);
        }else if(contract.data[key].type === 'string'){
          contractObj.data[key] = projectValues[count] + '';
        }
        contractObj.additional_fields[key] = {
          source: projectValues[5][0] && projectValues[5][0][key + (1 + i)] || '',
          verifier: projectValues[5][2] && projectValues[5][2][key + (1 + i)] || '',
          tied_document: Boolean(projectValues[5][1] && projectValues[5][1][key + (1 + i)])
        };
        count += 1;
      });
      return contractObj;
    }) || [];
  // contracts data set end
  const length = schema.contracts.length;
  // epc data set start
  Object.keys(schema.epc.data).map((key, i) => {

    if (schema.epc.data[key].type === 'boolean') {
      result.epc.data[key] = Boolean(projectValues[count + i]);
    } else if (schema.epc.data[key].type === 'integer' || schema.epc.data[key].type === 'number') {
      result.epc.data[key] = +projectValues[count + i];
    } else if (schema.epc.data[key].hasOwnProperty('list')) {
      result.epc.data[key] = projectValues[count + i];
      // valueSplit(projectValues[4][0][count + i]);
    } else {
      result.epc.data[key] = projectValues[count + i];
    }
    console.log(projectValues[5][0][key + (1 + length)]);
    result.epc.additional_fields[key] = {
      source: projectValues[5][0] && projectValues[5][0][key + (1 + length)] || '',
      verifier: projectValues[5][2] && projectValues[5][2][key + (1 + length)] || '',
      tied_document: Boolean(projectValues[5][1] && projectValues[5][1][key + (1 + length)])
    };
  // epc data set end

  });
  return result;
};

export const projectPreCreateingFiltering = (data,schema) => {
  const projectValues = Object.values(data);
  let count = 6;

  const result = {
    name: data.pname.slice(8, data.pname.length),
    user_schema: schema.user_schema.id,
    asset: {
      data: {},
      additional_fields: {},
      asset_schema_id: schema.assets.asset_schema_id,
    },
    contracts: [],
    epc: {
      data: {},
      additional_fields: {},
      epc_schema_id: schema.epc.epc_schema_id,
    }
  };

  // assets data set start
  Object.keys(schema.assets.data).map((key, i) => {
    if (schema.assets.data[key].type === 'integer' || schema.assets.data[key].type === 'number') {
      result.asset.data[key] = +projectValues[i + count];
    } else if( schema.assets.data[key].type === 'string'){
      result.asset.data[key] = projectValues[i + count] + '';
    } else if( schema.assets.data[key].type === 'object'){
      result.asset.data[key] = projectValues[i + count];

    }
    result.asset.additional_fields[key] = {
      source: projectValues[5][0] && key !== 'pname' && Object.values(projectValues[5][0])[i + 2] || '',
      verifier: projectValues[5][2] && key !== 'pname' && Object.values(projectValues[5][2])[i + 2] || '',
      tied_document: Boolean(projectValues[5][1] && key !== 'pname'&& Object.values(projectValues[5][1])[i + 2])
    }
  });
  // assets data set end

  count += Object.keys(schema.assets.data).length;

  // contracts data set start
  result.contracts = schema.contracts.length > 0
    && schema.contracts.map((contract) => {
      const contractObj = {
        data: {},
        additional_fields: {},
        contract_schema_id: contract.contract_schema_id,
      };
      Object.keys(contract.data).map((key) => {
        if (contract.data[key].type === 'integer' || contract.data[key].type === 'number') {
          contractObj.data[key] = +projectValues[count];
        } else if(contract.data[key].type === 'boolean'){
          contractObj.data[key] = Boolean(projectValues[count]);
        }else if(contract.data[key].type === 'string'){
          contractObj.data[key] = projectValues[count] + '';
        }
        contractObj.additional_fields[key] = {
          source: projectValues[5][0] && Object.values(projectValues[5][0])[count - 4] || '',
          verifier: projectValues[5][2] && Object.values(projectValues[5][2])[count - 4] || '',
          tied_document: Boolean(projectValues[5][1] && Object.values(projectValues[5][1])[count - 4])
        };
        count += 1;
      });
      return contractObj;
    }) || [];
  // contracts data set end

  // epc data set start
  Object.keys(schema.epc.data).map((key, i) => {

    if (schema.epc.data[key].type === 'boolean') {
      result.epc.data[key] = Boolean(projectValues[count + i]);
    } else if (schema.epc.data[key].type === 'integer' || schema.epc.data[key].type === 'number') {
      result.epc.data[key] = +projectValues[count + i];
    } else if (schema.epc.data[key].hasOwnProperty('list')) {
      result.epc.data[key] = projectValues[count + i];
      // valueSplit(projectValues[4][0][count + i]);
    } else {
      result.epc.data[key] = projectValues[count + i];
    }
    result.epc.additional_fields[key] = {
      source: projectValues[5][0] && Object.values(projectValues[5][0])[count +(i - 4)] || '',
      verifier: projectValues[5][2] && Object.values(projectValues[5][2])[count + (i - 4)] || '',
      tied_document: Boolean(projectValues[5][1] && Object.values(projectValues[5][1])[count + (i - 4)])
    };
    // epc data set end

  });
  return result;
};

export const projectNewRowCreateor = (data,name,projectIndex) => {
  const arrayOfObj = [data.assets, ...data.contracts, data.epc];
  let objectOfResult = {
    projectId: -1,
    projectIndex,
    assetSchemaId:data.user_schema.id,
    inputType: 'Project ' + name + ' data',
    pname: 'Project ' + name,
    participants: [
      {inputType: '', pname: 'Source'},
      {inputType: '', pname: 'Tied Document?'},
      {inputType: '', pname: 'Verifier'}
    ]
  };
  arrayOfObj.map((obj, i) => {
    const keys = Object.keys(obj.data);
    const values = Object.values(obj.data);
    keys.map((key, ind) => {
      objectOfResult[key + i] =  values[ind].value ;
      objectOfResult.participants[0][key + i] = '';
      objectOfResult.participants[1][key + i] = false;
      objectOfResult.participants[2][key + i] = '';

    })
  });
  return objectOfResult;
};


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/dataDef.js